import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import SiteLayout from '../components/SiteLayout';
import { componentRegistry } from '../builder-components';

const DynamicPage = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadPage();
  }, [slug]);

  const loadPage = async () => {
    try {
      setLoading(true);
      setError(null);

      const pagesQuery = query(
        collection(db, 'cms_pages'),
        where('slug', '==', slug),
        where('status', '==', 'published')
      );

      const snapshot = await getDocs(pagesQuery);

      if (snapshot.empty) {
        setError('Page not found');
        setPage(null);
      } else {
        const pageData = snapshot.docs[0].data();
        setPage(pageData);
      }
    } catch (err) {
      console.error('Error loading page:', err);
      setError('Failed to load page');
    } finally {
      setLoading(false);
    }
  };

  const renderComponent = (component) => {
    const Component = componentRegistry[component.type];
    if (!Component) {
      return null;
    }

    const style = component.styles || {};

    if (Component.builderConfig?.isContainer && component.children) {
      return (
        <div key={component.id} style={style}>
          <Component {...component.props}>
            {component.children.map(child => renderComponent(child))}
          </Component>
        </div>
      );
    }

    return (
      <div key={component.id} style={style}>
        <Component {...component.props} />
      </div>
    );
  };

  if (loading) {
    return (
      <SiteLayout>
        <div className="min-h-[60vh] flex items-center justify-center">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
            <p className="mt-4 text-muted-foreground">Loading...</p>
          </div>
        </div>
      </SiteLayout>
    );
  }

  if (error || !page) {
    return (
      <SiteLayout>
        <div className="min-h-[60vh] flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-4xl font-bold mb-4">404</h1>
            <p className="text-muted-foreground mb-8">Page not found</p>
            <a href="/" className="text-primary hover:underline">
              Go back home
            </a>
          </div>
        </div>
      </SiteLayout>
    );
  }

  return (
    <SiteLayout>
      {/* SEO would go here with react-helmet */}
      <div className="cms-page">
        {(page.components || []).map(component => renderComponent(component))}
      </div>
    </SiteLayout>
  );
};

export default DynamicPage;
